import { BranchType } from "@/features/church/config/branches/types/branch.types"
import { type BranchSummary } from "@/features/auth/services/user-branch-access-store"

type ResolveMemberLookupScopeInput = {
  accessibleBranches: BranchSummary[]
  activeBranchId?: string | null
  targetBranchId?: string | null
  forceParishContext?: boolean
}

export type MemberLookupScope = {
  branchId: string | null
  parishContext: boolean
  targetBranch: BranchSummary | null
}

function normalizeBranchId(value?: string | null) {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function resolveMemberLookupScope(input: ResolveMemberLookupScopeInput): MemberLookupScope {
  const systemBranch =
    input.accessibleBranches.find((branch) => branch.branchType === BranchType.System) ?? null

  const requestedBranchId = normalizeBranchId(input.targetBranchId)
  const fallbackBranchId = normalizeBranchId(input.activeBranchId)
  const effectiveBranchId = requestedBranchId ?? fallbackBranchId

  if (input.forceParishContext) {
    return {
      branchId: effectiveBranchId ?? systemBranch?.id ?? null,
      parishContext: true,
      targetBranch:
        input.accessibleBranches.find((branch) => branch.id === effectiveBranchId) ??
        systemBranch ??
        null,
    }
  }

  const targetBranch =
    input.accessibleBranches.find((branch) => branch.id === effectiveBranchId) ?? null

  const parishContext =
    targetBranch?.branchType === BranchType.System ||
    targetBranch?.slug === "parish"

  return {
    branchId: effectiveBranchId,
    parishContext,
    targetBranch,
  }
}
